import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
import { NormalHeading, SmallHeading } from '../../../../Components/Utils/Heading';
import capitalizeFirstLetter from '../../../../Components/Utils/Funcs';
import Logout from '../../../../Components/Icons/Logout';
import axiosInstance from '../../../../Services/axiosCommon';
import { useToast } from '../../../../Components/Others/ToastServices';
import ModalContainer from '../../../../Components/Others/ModalContainer';

function ViewUser() {
  const location = useLocation();
  const data = location.state.data;
  const from = location.state.from;

  const [forceLogoutModalOpen, setForceLogoutModalOpen] = useState(false);
  const toast = useToast();

  const handleConfirmForceLogout = async () => {
    try {
      const res = await axiosInstance.post(`/user/force-logout/${data?.userId}`);
      if (res?.data?.status === true || res?.status === 200) {
        toast.open({
          type: "success",
          message: "Success",
          description: res?.data?.message || res?.data?.msg || "User force logged out successfully.",
        });
        setForceLogoutModalOpen(false);
      } else if (res?.data?.status === false && res?.data?.error) {
        setForceLogoutModalOpen(false);
        toast.open({
          type: "error",
          message: "Error",
          description: res.data.error || "Failed to force logout user.",
        });
      } else {
        setForceLogoutModalOpen(false);
        toast.open({
          type: "warning",
          message: "Warning",
          description: res?.data?.msg || "Warning.",
        });
      }
    } catch (err) {
      setForceLogoutModalOpen(false);
      toast.open({
        type: "error",
        message: "Error",
        description: err.response?.data?.error || err.response?.data?.message || "Failed to force logout user.",
      });
    }
  };

  return (
    <div className='w-full h-full px-4 py-2'>
      <div className="w-full h-[46px]  flex justify-between ">
        <Breadcrumb
          items={
            [
              {
                name: "Settings",
                link: "/settings/user"
              },
              {
                name: "User",
                link: "/settings/user"
              },
              {
                name: "View User"
              }]
          }
        />
        <div className=" flex gap-2 items-center">
          <button
            onClick={() => setForceLogoutModalOpen(true)}
            className="h-8 px-2 rounded-md bg-red-600 hover:bg-red-700 text-white text-xs font-medium flex items-center gap-1 cursor-pointer"
            title="Force Logout"
          >
            <Logout width={32} height={32} color="#ffffff" title="Force Logout" />
            <span>Force Logout</span>
          </button>
          <Link to={'/settings/user'}><BackButton link={true} /></Link>
          <Link to={`/settings/user/edit/${data?.userId}`} state={{ data: data, from: `/settings/user/view/${data.userId}` }}><EditButton height='8' /></Link>
        </div>
      </div>
      <ModalContainer
        visiable={forceLogoutModalOpen}
        title="Force Logout"
        content={`Are you sure you want to force logout ${data?.name || "this user"}?`}
        handleClick={handleConfirmForceLogout}
        closeModal={() => setForceLogoutModalOpen(false)}
      />
      <div className="w-full mx-auto h-[calc(100vh-145px)]  rounded-md overflow-hidden overflow-y-auto p-3">
        <div className="flex flex-col lg:flex-row gap-4 w-full h-full">

          <div className="lg:w-[60%] w-full h-full lg:h-auto  bg-white rounded-lg drop-shadow-lg  overflow-y-auto  px-4  flex  flex-col">
            <div className="py-4">
              <NormalHeading title={data?.name || '-'} />
            </div>
            <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
              <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>User ID</p>
              <p className='w-1/2 py-2 pl-5  text-xs  text-[#606279]'>{data?.userId || '-'}</p>
            </div>
            {/* <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Name</p>
                    <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.name || '-'}</p>
                  </div> */}
            <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
              <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Email</p>
              <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.email || '-'}</p>
            </div>
            <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
              <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Phone</p>
              <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.phone?.number || '-'}</p>
            </div>
            <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
              <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Division</p>
              <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.division || '-'}</p>
            </div>
            <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
              <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Designation</p>
              <p className='w-1/2 py-2 pl-5 text-xs text-[#606279]'>
                {data?.designation ? capitalizeFirstLetter
                  (data.designation) : '-'}
              </p>
            </div>

            {data?.designation === "salesman" && (<>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Monthly Target</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.monthlyTar || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Quarterly Target</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.quarterlyTar || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>HalfYear Target</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.halfYearTar || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Yearly Target</p>
                <p className='w-1/2 py-2 pl-5 text-xs  text-[#606279]'>{data?.yearlyTar || '-'}</p>
              </div>
            </>)}
            <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
              <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Status</p>
              <p className='w-1/2 py-2 pl-5  text-xs  text-[#606279]'>{data?.status == "" ? "In-Active" :
                data?.status == 1 ? "Active" :
                  "-"}
              </p>
            </div>
          </div>

          <div className="lg:w-[40%] w-full  py-4 bg-white rounded-lg drop-shadow-lg px-4">
            <SmallHeading title={"User Image"} />
            <div className="w-full flex items-center justify-center mt-8">
              {data?.userImage?.file ? (
                <div className="w-[80%] h-[80%] rounded-[5%] overflow-hidden border border-gray-300">
                  <img
                    src={data.userImage.file}
                    alt={`${data?.name}'s image`}
                    className="object-cover w-full h-full"
                  />
                </div>
              ) : (
                <div className="flex items-center justify-center w-full h-40 rounded bg-gray-100 text-gray-500">
                  <p>No User Image available</p>
                </div>
              )}
            </div>
          </div>




        </div>

      </div>

    </div>



  )
}

export default ViewUser;